import ApiService from "@/services/api.service";

// ACTIONS
export const LIST_ROLES = "listRoles";
export const PAGINATED_LIST_ROLES = "paginatedListRoles";
export const CREATE_ROLE = "createRole";
export const GET_ROLE = "getRole";
export const UPDATE_ROLE = "updateRole";
export const DELETE_ROLE = "deleteRole";

// MUTATIONS
export const SET_LIST_ROLES = "setListRoles";
export const SET_PAGINATED_LIST_ROLES = "setPaginatedListRoles";
export const SET_ERROR = "setError";

const state = {
    error: {},
    listRole: [],
    paginatedListRoles: {},
};

const getters = {};

const actions = {
    [LIST_ROLES](context, query) {
        return new Promise((resolve) => {
            ApiService.get(`Roles?${query}`)
                .then(({ data }) => {
                    context.commit(SET_PAGINATED_LIST_ROLES, data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    if (response) {
                        context.commit(SET_ERROR, response?.data?.message);
                        setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                    }
                });
        });
    },
    [PAGINATED_LIST_ROLES](context, filters) {
        return new Promise((resolve) => {
            ApiService.post(`Roles/Filtered`, filters)
                .then(({ data }) => {
                    context.commit(SET_PAGINATED_LIST_ROLES, data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response?.data?.message);
                    setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                });
        });
    },

    [CREATE_ROLE](context, params) {
        return new Promise((resolve) => {
            ApiService.post(`Roles`, params)
                .then((res) => {
                    resolve(res);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response?.data?.message);
                    setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                });
        });
    },

    [GET_ROLE](context, id) {
        return new Promise((resolve) => {
            ApiService.download(`Roles`, id)
                .then((res) => {
                    resolve(res);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response?.data?.message);
                    setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                });
        });
    },
    [UPDATE_ROLE](context, params) {
        return new Promise((resolve) => {
            ApiService.update(`Roles`, params.id, params)
                .then((res) => {
                    resolve(res);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response?.data?.message);
                    setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                });
        });
    },

    [DELETE_ROLE](context, id) {
        return new Promise((resolve) => {
            ApiService.delete(`Roles`, id)
                .then((res) => {
                    resolve(res);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response?.data?.message);
                    setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                });
        });
    },
};

// MUTATIONS

const mutations = {
    [SET_ERROR](state, error) {
        state.error = error;
    },
    [SET_LIST_ROLES](state, roles) {
        state.listRole.push(...roles);
    },
    [SET_PAGINATED_LIST_ROLES](state, roles) {
        state.paginatedListRoles = Object.assign({}, roles);
    },
};

export default {
    state,
    actions,
    mutations,
    getters,
};
